export const printPO = (po) => {
  const dateStr = new Date(po.created_at).toLocaleDateString("en-IN");
  
  const itemRows = (po.items || []).map((item, index) => {
    return `
      <tr>
        <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${index + 1}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">${item.name}</td>
        <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.quantity}</td>
        <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">₹${Number(item.price || 0).toFixed(2)}</td>
        <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">₹${Number(item.total || (item.quantity * item.price)).toFixed(2)}</td>
      </tr>
    `;
  }).join('');

  const html = `
    <html>
      <head>
        <title>Purchase Order ${po.po_number || ''}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 0; padding: 20px; color: #333; }
          .header { text-align: center; margin-bottom: 30px; }
          .header h1 { margin: 0; font-size: 24px; color: #1e3a8a; }
          .header p { margin: 5px 0; color: #666; font-size: 14px; }
          .details { display: flex; justify-content: space-between; margin-bottom: 30px; }
          .details div { width: 48%; }
          .details h3 { margin-top: 0; margin-bottom: 10px; font-size: 16px; border-bottom: 1px solid #eee; padding-bottom: 5px; }
          .details p { margin: 4px 0; font-size: 14px; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 30px; }
          th { background-color: #f8fafc; border: 1px solid #ddd; padding: 10px; text-align: left; font-size: 14px; color: #1e293b; }
          td { font-size: 14px; }
          .total-row { font-weight: bold; }
          .footer { margin-top: 50px; display: flex; justify-content: space-between; font-size: 14px; }
          .signature { border-top: 1px solid #333; width: 200px; text-align: center; padding-top: 10px; margin-top: 60px; }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>PURCHASE ORDER</h1>
          <p>PO Number: <b>${po.po_number || 'Draft'}</b> | Date: ${dateStr}</p>
        </div>
        
        <div class="details">
          <div>
            <h3>Supplier Details</h3>
            <p><strong>Name:</strong> ${po.supplier_name}</p>
            ${po.supplier_contact ? `<p><strong>Contact:</strong> ${po.supplier_contact}</p>` : ''}
          </div>
          <div>
            <h3>Order Details</h3>
            <p><strong>Generated By:</strong> ${po.generated_by || 'Admin'}</p>
            <p><strong>Status:</strong> Approved</p>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th style="width: 5%; text-align: center;">#</th>
              <th style="width: 45%;">Item Description</th>
              <th style="width: 15%; text-align: center;">Quantity</th>
              <th style="width: 15%; text-align: right;">Rate</th>
              <th style="width: 20%; text-align: right;">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${itemRows}
            <tr class="total-row">
              <td colspan="4" style="border: 1px solid #ddd; padding: 12px; text-align: right;">Total Amount:</td>
              <td style="border: 1px solid #ddd; padding: 12px; text-align: right; font-size: 16px;">₹${Number(po.total_amount || 0).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>

        ${po.notes ? `<div><strong>Notes/Instructions:</strong><br><p style="font-size: 14px;">${po.notes}</p></div>` : ''}

        <div class="footer">
          <div class="signature">Authorised Signatory</div>
        </div>
      </body>
    </html>
  `;

  const win = window.open("", "_blank");
  win.document.write(html);
  win.document.close();
  win.onload = () => {
    win.focus();
    win.print();
    setTimeout(() => win.close(), 500);
  };
};

export const whatsappPO = (po) => {
  if (!po.supplier_contact) {
    alert("Supplier contact number is missing!");
    return;
  }
  
  const dateStr = new Date(po.created_at).toLocaleDateString("en-IN");
  let itemsText = (po.items || []).map(i => `${i.name} (Qty: ${i.quantity})`).join('%0A- ');
  
  const text = `*NEW PURCHASE ORDER*%0A%0A*PO Number:* ${po.po_number || 'Draft'}%0A*Date:* ${dateStr}%0A*Supplier:* ${po.supplier_name}%0A%0A*Items:*%0A- ${itemsText}%0A%0A*Total Amount:* ₹${Number(po.total_amount || 0).toFixed(2)}%0A%0A${po.notes ? `*Notes:* ${po.notes}%0A%0A` : ''}Please confirm receipt of this order. Thank you.`;
  
  const phone = po.supplier_contact.replace(/\D/g, "");
  const waUrl = `https://wa.me/91${phone}?text=${text}`;
  window.open(waUrl, "_blank");
};
